import { SpecialUrlCode } from '../../urlCodeHelpers';
import { AbstractPathResolver, PathResolveResult } from '../PathResolver';

const kUseDefaultState = true;

export class ShowcasePathResolver extends AbstractPathResolver {
  resolveStateFromPath(): PathResolveResult {
    const { urlPath, params } = this.context;

    const defaultState = this.getDefaultState({
      screens: {
        showcase: this.context.options?.screens?.showcase,
      },
    });

    const reel = params.get('reel')?.toLowerCase();

    if (
      !urlPath.includes('/') &&
      params.has('reel') &&
      (!reel || reel === 'true' || reel === '1')
    ) {
      return {
        index: 0,
        routes: defaultState?.routes ?? [],
      };
    }

    if (SpecialUrlCode.isCurrentShowSpecialUrlCode(urlPath)) {
      return kUseDefaultState
        ? defaultState
        : {
            index: 1,
            routes: [
              {
                name: 'home',
              },
              ...(defaultState?.routes ?? [
                {
                  name: 'showcase',
                  params: {
                    urlCode: urlPath,
                  },
                },
              ]),
            ],
          };
    }
  }
}
